import React from "react";

import { PageMessage } from "@picklebet/ui";
import { ReactComponent as VerifiedIcon } from "assets/illustrations/verified.svg";
import { useIsVerified } from "@/hooks/useIsVerified";
import NextBettingButtons from "@/features/shell/components/shared/NextBettingButtons";

type UnverifiedOnlyProps = {
  children: React.ReactNode;
};

const UnverifiedOnly = ({ children }: UnverifiedOnlyProps) => {
  const verified = useIsVerified();

  if (verified) {
    return (
      <PageMessage
        title={`Account Verified`}
        image={<VerifiedIcon />}
        subTitle={`Your account has already been verified!`}
      >
        <NextBettingButtons />
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { UnverifiedOnly };
